/* ---
  Wunsch-Funktion / Wunschliste (snippets/wish-button.liquid)

  Sammeln:   Knopf „Auf die Wunschliste" legt die gewählte Dose auf die Liste
             (localStorage, kein Konto) und öffnet das Wunschlisten-Fenster:
             gesammelte Dosen, Name, Nachricht → ein Link (Web Share API,
             sonst Link kopieren / WhatsApp / E-Mail).
  Öffnen:    Eine Dose  → Produkt-URL mit ?view=wish (data-mode="page",
                          templates/product.wish.json)
             Mehrere    → /collections/all?view=wishlist&items=… (data-mode="list",
                          templates/collection.wishlist.json)
             „Jetzt schenken" / „Alles schenken" legen Variante(n) + Menge in
             den Warenkorb. Über ?view=… erkennt auch Liquid den Wunsch und gibt
             eine eigene Messenger-Vorschau aus (snippets/open-graph.liquid) —
             URL-Parameter sieht Liquid nicht.

  Links (bewusst kurz — WhatsApp zeigt die Adresse immer ausgeschrieben):
          {root}products/{handle}?view=wish&v={Nr. der Variante}&q={Menge}&f={Name}
          {root}collections/all?view=wishlist&i={handle}.{Nr.}.{Menge}~…&f={Name}
  Die Nachricht steht im geteilten Text, nicht im Link. Ältere, lange Parameter
  (variant, qty, from, msg, items) werden weiter gelesen.
  Die gewählte Variante kommt aus dem id-Feld des Produktformulars der Kaufbox —
  so funktioniert es mit allen Kaufboxen, auch mit den eigenen Chips von
  ec-lf-product / ec-vod-product. Hat die Set-Auswahl (bundle-offer) eine fremde
  Varianten-ID eingetragen, bleibt die zuletzt gewählte eigene Variante stehen.

  Werte aus der URL landen nur per textContent im Dokument, nie als HTML.
  Tracking ohne Namen und Nachrichten.
--- */

(function () {
  if (window.customElements.get('ec-wish')) return;

  var MAX_FROM = 40;
  var MAX_MSG = 140;
  var MAX_QTY = 5;
  var MAX_ITEMS = 12;
  var NAME_KEY = 'ec-wish-name';
  var LIST_KEY = 'ec-wishlist';

  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }

  function make(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  /* Platzhalter ersetzen — split/join statt replace, damit „$&" o. Ä. im Namen nichts auslöst */
  function fill(tpl, token, value) {
    return String(tpl || '').split(token).join(value);
  }

  function rootPath(data) {
    var root = (data && data.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  /* In der Theme-Vorschau bekommen Links die Vorschau-ID, sonst öffnen sie (und WhatsApp)
     das Live-Theme. Shopify entfernt den Parameter nach dem ersten Aufruf aus der
     Adresse, darum zählt die Rolle des Themes. */
  function previewSuffix() {
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.id && theme.role && theme.role !== 'main') {
      return '&preview_theme_id=' + encodeURIComponent(theme.id);
    }
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    return preview ? '&preview_theme_id=' + encodeURIComponent(preview) : '';
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, data));
      }
    } catch (e) {}
  }

  /* Preis aus Cent im Format des Shops, z. B. „€{{amount_with_comma_separator}}" */
  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    var tpl = String(format || '€{{amount_with_comma_separator}}');
    var match = tpl.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    function group(num, decimals, thousand, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
      return parts.join(decimal);
    }
    var out;
    switch (kind) {
      case 'amount_no_decimals': out = group(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = group(value, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = group(value, 2, ' ', ','); break;
      default: out = group(value, 2, ',', '.');
    }
    return match ? tpl.replace(match[0], out) : out;
  }

  /* Jetzt in Wiener Zeit als „JJJJ-MM-TT HH:MM" — direkt vergleichbar */
  function nowVienna() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (part) { p[part.type] = part.value; });
      return p.year + '-' + p.month + '-' + p.day + ' ' + p.hour + ':' + p.minute;
    } catch (e) {
      return new Date().toISOString().slice(0, 16).replace('T', ' ');
    }
  }

  /* Bestellschluss „JJJJ-MM-TT" oder „JJJJ-MM-TT HH:MM" (Wiener Zeit) als Text in der
     Seitensprache, z. B. „22. Dezember um 10:00". Danach leer — der Hinweis verschwindet. */
  function deadlineLabel(value, lang) {
    var m = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return '';
    var hasTime = m[4] != null;
    var hh = hasTime ? ('0' + m[4]).slice(-2) : '23';
    var mm = hasTime ? m[5] : '59';
    if (nowVienna() >= m[1] + '-' + m[2] + '-' + m[3] + ' ' + hh + ':' + mm) return '';

    var opts = { day: 'numeric', month: 'long' };
    if (hasTime) { opts.hour = '2-digit'; opts.minute = '2-digit'; }
    try {
      return new Intl.DateTimeFormat(lang || undefined, opts)
        .format(new Date(+m[1], +m[2] - 1, +m[3], +hh, +mm));
    } catch (e) {
      return m[3] + '.' + m[2] + '.' + (hasTime ? ' ' + hh + ':' + mm : '');
    }
  }

  /* ---------- Wunschliste im Browser ---------- */

  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,120}$/;

  function validItem(item) {
    return item && HANDLE_RE.test(item.h) && (/^\d{1,20}$/.test(String(item.v)) || /^\d{1,3}$/.test(String(item.n)));
  }

  function loadList() {
    try {
      var list = JSON.parse(window.localStorage.getItem(LIST_KEY) || '[]');
      return Array.isArray(list) ? list.filter(validItem).slice(0, MAX_ITEMS) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try { window.localStorage.setItem(LIST_KEY, JSON.stringify(list.slice(0, MAX_ITEMS))); } catch (e) {}
  }

  /* ---------- Warenkorb ---------- */

  function postJSON(root, path, body, fallbackError) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || fallbackError);
        return json;
      });
    });
  }

  /* items: [{ id, quantity }] — legt alles in den Warenkorb und vermerkt „Wunsch von" */
  function giftToCart(data, items, from) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || rootPath(data);
    if (root.slice(-1) !== '/') root += '/';
    var error = (data.i18n && data.i18n.error) || 'Error';

    var lines = items.map(function (item) {
      var line = { id: item.id, quantity: item.quantity };
      if (from) line.properties = { _wish_from: from };
      return line;
    });

    return postJSON(root, 'cart/add.js', { items: lines }, error).then(function () {
      return postJSON(root, 'cart/update.js', { attributes: { 'Wunsch von': from || '–' } }, error);
    });
  }

  function openCart(data) {
    var overlay = window.KROWN && window.KROWN.settings && window.KROWN.settings.cart_action === 'overlay';
    if (overlay && typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else {
      window.location.href = data.cartUrl || '/cart';
    }
  }

  /* ---------- Dialog ---------- */

  function lockPage(on) {
    document.documentElement.classList.toggle('ec-wish-lock', on);
  }

  function openDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    lockPage(true);
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    lockPage(false);
  }

  class EcWish extends HTMLElement {

    connectedCallback() {
      if (this._ready) return;
      var dataNode = this.querySelector('[data-wish-data]');
      if (!dataNode) return;
      try {
        this.data = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }
      this._ready = true;
      this.i18n = this.data.i18n || {};
      this.variants = Array.isArray(this.data.variants) ? this.data.variants : [];

      if (this.dataset.mode === 'list') {
        this.renderListPage();
        return;
      }

      this.current = this.variantById(this.dataset.variant) || this.firstAvailable() || this.variants[0];

      if (this.dataset.mode === 'page') {
        this.renderPage();
        return;
      }

      this.form = document.getElementById(this.dataset.form);
      this.trigger = this.querySelector('[data-wish-open]');
      this.label = this.querySelector('[data-wish-label]');
      this.sheet = this.querySelector('.ec-wish-sheet');

      /* Die Kaufbox schreibt Variante und Menge erst nach dem Klick — danach lesen */
      var scope = this.closest('.shopify-section') || document;
      var later = function () { setTimeout(this.sync.bind(this), 0); }.bind(this);
      scope.addEventListener('change', later);
      scope.addEventListener('click', later);
      this.sync();

      if (this.sheet) this.bindSheet();
    }

    /* ---------- Variante ---------- */

    variantById(id) {
      var num = parseInt(id, 10);
      if (!num) return null;
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].id === num) return this.variants[i];
      }
      return null;
    }

    firstAvailable() {
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].available) return this.variants[i];
      }
      return null;
    }

    readForm() {
      var state = { id: null, qty: 1 };
      if (!this.form) return state;
      var idField = this.form.elements.namedItem('id');
      var qtyField = this.form.elements.namedItem('quantity');
      if (idField) state.id = idField.value;
      if (qtyField) state.qty = parseInt(qtyField.value, 10) || 1;
      return state;
    }

    /* In der Kaufbox gewähltes Set (snippets/bundle-offer.liquid) — dann kommt das Set
       auf die Wunschliste statt der einzelnen Dose. Sets haben eine einzige Variante;
       verlinkt wird trotzdem über die Varianten-ID, das bleibt auch später richtig. */
    activeSet() {
      var scope = this.closest('.shopify-section') || document;
      var radio = scope.querySelector('bundle-offer .ec-offer__radio:checked');
      if (!radio || !radio.value || !radio.dataset.handle) return null;
      var card = radio.closest('.ec-offer__card');
      var title = card && card.querySelector('.ec-offer__title');
      var img = card && card.querySelector('.ec-offer__media img');
      return {
        h: radio.dataset.handle,
        v: radio.value,
        t: title ? title.textContent.trim() : radio.dataset.handle,
        p: radio.dataset.price || '',
        i: img ? (img.currentSrc || img.src) : ''
      };
    }

    onList() {
      var id = this.set ? this.set.v : this.current && this.current.id;
      return loadList().some(function (item) { return String(item.v) === String(id); });
    }

    sync() {
      this.set = this.activeSet();
      var picked = this.variantById(this.readForm().id);
      if (picked) this.current = picked;
      var ok = !!(this.set || (this.current && this.current.available));
      if (this.trigger) this.trigger.hidden = !ok;
      this.toggleAttribute('data-unavailable', !ok);

      var on = ok && this.onList();
      this.classList.toggle('is-on-list', on);
      if (this.label) this.label.textContent = on ? this.i18n.buttonOn : this.i18n.button;
    }

    eventData(variant, extra) {
      var v = variant || this.current;
      return Object.assign({
        product_id: this.data.productId,
        product_handle: this.data.handle,
        variant_id: v ? v.id : null
      }, extra || {});
    }

    /* ---------- Sammeln ---------- */

    bindSheet() {
      var s = this.sheet;
      this.formEl = s.querySelector('[data-wish-form]');
      this.nameInput = s.querySelector('[data-wish-name]');
      this.msgInput = s.querySelector('[data-wish-msg]');
      this.counter = s.querySelector('[data-wish-count]');
      this.formError = s.querySelector('[data-wish-form-error]');
      this.shareBox = s.querySelector('[data-wish-share]');
      this.sentBox = s.querySelector('[data-wish-sent]');
      this.linkInput = s.querySelector('[data-wish-link]');
      this.copyBtn = s.querySelector('[data-wish-channel="copy"]');
      this.addedNote = s.querySelector('[data-wish-added]');
      this.listEl = s.querySelector('[data-wish-list]');
      this.emptyNote = s.querySelector('[data-wish-empty]');

      if (this.trigger) {
        this.trigger.addEventListener('click', this.addAndOpen.bind(this));
      }

      var shut = function () { closeDialog(s); };
      s.querySelector('[data-wish-close]').addEventListener('click', shut);
      var more = s.querySelector('[data-wish-continue]');
      if (more) more.addEventListener('click', shut);

      /* Klick auf den abgedunkelten Rand schliesst */
      s.addEventListener('click', function (e) {
        if (e.target === s) shut();
      });

      s.addEventListener('close', function () {
        lockPage(false);
        this.sync();
      }.bind(this));

      this.msgInput.addEventListener('input', this.updateCount.bind(this));
      this.nameInput.addEventListener('input', function () {
        this.formError.hidden = true;
      }.bind(this));

      this.formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        this.send();
      }.bind(this));

      s.querySelectorAll('[data-wish-channel]').forEach(function (node) {
        node.addEventListener('click', function (e) {
          this.useChannel(node.getAttribute('data-wish-channel'), e);
        }.bind(this));
      }.bind(this));
    }

    updateCount() {
      this.counter.textContent = this.msgInput.value.length + '/' + MAX_MSG;
    }

    resetSheet() {
      this.formEl.hidden = false;
      this.shareBox.hidden = true;
      this.sentBox.hidden = true;
      this.formError.hidden = true;
      this.copyBtn.textContent = this.i18n.copyLink || this.copyBtn.textContent;
      this.updateCount();
    }

    /* Gewählte Dose auf die Liste (gleiche Variante: Menge aktualisieren) und Fenster öffnen */
    addAndOpen() {
      this.sync();
      var set = this.set;
      var v = this.current;
      if (!set && (!v || !v.available)) return;

      var item = set
        ? { h: set.h, v: set.v, q: 1, t: set.t, vt: '', p: set.p, i: set.i }
        : {
            h: this.data.handle,
            v: v.id,
            n: this.variants.indexOf(v) + 1,
            q: clamp(this.readForm().qty, 1, MAX_QTY),
            t: this.data.title,
            vt: v.title || '',
            p: v.price,
            i: this.data.image || v.image || ''
          };

      var list = loadList().filter(function (x) { return String(x.v) !== String(item.v); });
      list.unshift(item);
      saveList(list);
      track('wish_created', set
        ? { product_handle: set.h, variant_id: set.v, set: true, items: list.length }
        : this.eventData(v, { items: list.length }));
      this.sync();

      var name = item.t + (item.vt ? ' · ' + item.vt : '');
      this.addedNote.textContent = fill(this.i18n.added, '%ITEM%', name);
      this.addedNote.hidden = false;
      this.openSheet();
    }

    openSheet() {
      this.resetSheet();
      this.renderSheetList();

      if (!this.nameInput.value) {
        try {
          var saved = window.localStorage.getItem(NAME_KEY);
          if (saved) this.nameInput.value = saved.slice(0, MAX_FROM);
        } catch (e) {}
      }

      openDialog(this.sheet);
      (this.nameInput.value ? this.msgInput : this.nameInput).focus();
    }

    renderSheetList() {
      var list = loadList();
      var t = this.i18n;
      this.listEl.textContent = '';

      list.forEach(function (item) {
        var li = make('li', 'ec-wish-list__item');
        var media = make('span', 'ec-wish-list__media');
        if (item.i) {
          var img = make('img');
          img.src = item.i;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          media.appendChild(img);
        }
        li.appendChild(media);

        var text = make('span', 'ec-wish-list__text');
        text.appendChild(make('span', 'ec-wish-list__title', item.t));
        text.appendChild(make('span', 'ec-wish-list__meta',
          (item.q > 1 ? item.q + ' × ' : '') + (item.vt ? item.vt + ' · ' : '') + (item.p || '')));
        li.appendChild(text);

        var remove = make('button', 'ec-wish-list__remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', t.remove + ': ' + item.t + (item.vt ? ' · ' + item.vt : ''));
        remove.innerHTML = '<svg width="12" height="12" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.3"/></svg>';
        remove.addEventListener('click', function () {
          saveList(loadList().filter(function (x) { return String(x.v) !== String(item.v); }));
          this.addedNote.hidden = true;
          this.renderSheetList();
          this.sync();
        }.bind(this));
        li.appendChild(remove);

        this.listEl.appendChild(li);
      }.bind(this));

      var empty = list.length === 0;
      this.emptyNote.hidden = !empty;
      this.formEl.querySelector('[type="submit"]').disabled = empty;
    }

    /* Eine Dose: eigene ruhige Produkt-Seite. Mehrere: Wunschlisten-Seite.
       Kurz gehalten: Nummer der Variante statt langer ID, Menge nur wenn > 1. */
    buildLink(list, from) {
      var root = window.location.origin + rootPath(this.data);
      var tail = (from ? '&f=' + encodeURIComponent(from) : '') + previewSuffix();

      if (list.length === 1) {
        var one = list[0];
        var pick = one.n ? 'v=' + one.n : 'variant=' + one.v;
        return root + 'products/' + one.h + '?view=wish&' + pick + (one.q > 1 ? '&q=' + one.q : '') + tail;
      }

      var items = list.map(function (item) {
        return item.n ? item.h + '.' + item.n + (item.q > 1 ? '.' + item.q : '') : item.h + '.id' + item.v;
      }).join('~');
      return root + 'collections/all?view=wishlist&i=' + items + tail;
    }

    /* Der geteilte Text trägt den Zusammenhang, auch wenn die Vorschau fehlt */
    buildText(list, msg) {
      var names = list.map(function (item) {
        return (item.q > 1 ? item.q + ' × ' : '') + item.t + (item.vt ? ' · ' + item.vt : '');
      }).join(', ');
      return (this.i18n.shareText || '') + ' ' + names + (msg ? '\n' + msg : '');
    }

    send() {
      var list = loadList();
      if (!list.length) return;

      var from = this.nameInput.value.trim().slice(0, MAX_FROM);
      if (!from) {
        this.formError.hidden = false;
        this.nameInput.focus();
        return;
      }

      var msg = this.msgInput.value.trim().slice(0, MAX_MSG);
      try { window.localStorage.setItem(NAME_KEY, from); } catch (e) {}

      this.link = this.buildLink(list, from);
      this.text = this.buildText(list, msg);
      this.full = this.text + '\n' + this.link;
      this.shareData = { items: list.length };

      /* Nur ein Text mit Link darin: manche Apps hängen eine extra übergebene URL
         ein zweites Mal an */
      if (navigator.share) {
        navigator.share({ text: this.full })
          .then(function () {
            track('wish_shared', this.eventData(null, { channel: 'native', items: list.length }));
            this.showSent(false);
          }.bind(this))
          .catch(function (err) {
            /* Abgebrochen: Fenster bleibt, wie es war. Sonst Ausweich-Knöpfe zeigen. */
            if (err && err.name === 'AbortError') return;
            this.showChannels();
          }.bind(this));
      } else {
        this.showChannels();
      }
    }

    showChannels() {
      this.linkInput.value = this.link;
      this.sheet.querySelector('[data-wish-channel="whatsapp"]').href =
        'https://wa.me/?text=' + encodeURIComponent(this.full);
      this.sheet.querySelector('[data-wish-channel="mail"]').href =
        'mailto:?subject=' + encodeURIComponent(this.text.split('\n')[0]) +
        '&body=' + encodeURIComponent(this.text + '\n\n' + this.link);
      this.formEl.hidden = true;
      this.shareBox.hidden = false;
    }

    showSent(keepChannels) {
      this.formEl.hidden = true;
      this.shareBox.hidden = !keepChannels;
      this.sentBox.hidden = false;
    }

    useChannel(kind, e) {
      var data = this.eventData(null, Object.assign({ channel: kind }, this.shareData));

      if (kind === 'copy') {
        e.preventDefault();
        var done = function () {
          this.copyBtn.textContent = this.i18n.copied || this.copyBtn.textContent;
          track('wish_shared', data);
          this.showSent(true);
        }.bind(this);
        var legacy = function () {
          this.linkInput.value = this.full;
          this.linkInput.select();
          try { document.execCommand('copy'); } catch (err) {}
          done();
        }.bind(this);

        /* Ganze Nachricht kopieren, nicht nur den Link — sonst fehlt beim Einfügen der Zusammenhang */
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(this.full).then(done, legacy);
        } else {
          legacy();
        }
        return;
      }

      /* WhatsApp / E-Mail: der Link öffnet sich normal */
      track('wish_shared', data);
      setTimeout(this.showSent.bind(this, true), 300);
    }

    /* ---------- Gemeinsames für die Empfänger-Seiten ---------- */

    readWish() {
      var params = new URLSearchParams(window.location.search);
      return {
        from: (params.get('f') || params.get('from') || '').trim().slice(0, MAX_FROM),
        msg: (params.get('m') || params.get('msg') || '').trim().slice(0, MAX_MSG),
        params: params
      };
    }

    deadlineText() {
      var label = deadlineLabel(this.data.deadlineDate, document.documentElement.lang);
      if (!label) return '';

      var tpl = this.data.deadlineText || this.i18n.deadline || '';
      return fill(fill(tpl, '{date}', label), '%DATE%', label);
    }

    productUrl(handle, variantId) {
      return rootPath(this.data) + 'products/' + encodeURIComponent(handle) + '?variant=' + variantId + previewSuffix();
    }

    noteEl(msg) {
      var note = make('p', 'ec-wish-card__msg');
      note.appendChild(make('q', null, msg));
      return note;
    }

    errorEl() {
      var error = make('p', 'ec-wish__error');
      error.setAttribute('role', 'alert');
      error.hidden = true;
      return error;
    }

    giftButton(label, items, from, error, extraTrack) {
      var button = make('button', 'ec-wish__btn', label);
      button.type = 'button';
      button.addEventListener('click', function () {
        button.disabled = true;
        button.classList.add('is-working');
        error.hidden = true;

        giftToCart(this.data, items, from)
          .then(function () {
            track('wish_gifted', Object.assign({ items: items.length }, extraTrack || {}));
            openCart(this.data);
          }.bind(this))
          .catch(function (err) {
            error.textContent = (err && err.message) || this.i18n.error;
            error.hidden = false;
          }.bind(this))
          .finally(function () {
            button.disabled = false;
            button.classList.remove('is-working');
          });
      }.bind(this));
      return button;
    }

    mount(card) {
      var slot = this.querySelector('[data-wish-slot]') || this;
      slot.textContent = '';
      slot.appendChild(card);
    }

    /* ---------- Eine Dose (?view=wish) ---------- */

    renderPage() {
      var w = this.readWish();
      var pos = parseInt(w.params.get('v'), 10);
      var v = (pos > 0 && this.variants[pos - 1]) || this.variantById(w.params.get('variant')) || this.firstAvailable() || this.variants[0];
      if (!v) return;
      var qty = clamp(parseInt(w.params.get('q') || w.params.get('qty'), 10) || 1, 1, MAX_QTY);
      var t = this.i18n;

      var card = make('article', 'ec-wish-dialog ec-wish-card ec-wish-card--page');
      var inner = make('div', 'ec-wish-card__inner');

      /* Hauptbild zuerst: die Variantenbilder zeigen die Dose klein im Größenvergleich */
      var imgSrc = this.data.image || v.image;
      if (imgSrc) {
        var media = make('div', 'ec-wish-card__media');
        var img = make('img');
        img.src = imgSrc;
        img.alt = this.data.title;
        img.width = 900;
        img.height = 506;
        media.appendChild(img);
        inner.appendChild(media);
      }

      inner.appendChild(make('p', 'ec-wish__eyebrow', w.from ? fill(t.listFrom, '%NAME%', w.from) : t.listAnon));
      inner.appendChild(make('h1', 'ec-wish__title', this.data.title));
      inner.appendChild(make('p', 'ec-wish-card__price',
        (qty > 1 ? qty + ' × ' : '') + (v.title ? v.title + ' · ' : '') + v.price));

      if (w.msg) inner.appendChild(this.noteEl(w.msg));

      var deadline = this.deadlineText();
      if (deadline) inner.appendChild(make('p', 'ec-wish-card__deadline', deadline));

      var error = this.errorEl();
      inner.appendChild(error);

      var actions = make('div', 'ec-wish-card__actions');
      if (v.available) {
        actions.appendChild(this.giftButton(t.giftNow, [{ id: v.id, quantity: qty }], w.from, error,
          this.eventData(v)));
      } else {
        actions.appendChild(make('p', 'ec-wish-card__unavailable', t.unavailable));
        var contact = make('a', 'ec-wish__btn ec-wish__btn--ghost', t.contact);
        contact.href = this.data.contactUrl || '/pages/contact-1';
        actions.appendChild(contact);
      }

      var look = make('a', 'ec-wish-card__later', t.viewFirst);
      look.href = this.productUrl(this.data.handle, v.id);
      actions.appendChild(look);
      inner.appendChild(actions);

      card.appendChild(inner);
      this.mount(card);
      track('wish_opened', this.eventData(v, { items: 1 }));
    }

    /* ---------- Mehrere Dosen (?view=wishlist&items=…) ---------- */

    /* Kurz: „handle.nr.menge~…" (nr = Position der Variante, „idNNN" = Varianten-ID).
       Alt: „handle:variante:menge,…" */
    parseItems(params) {
      var seen = {};
      var short = params.get('i');
      var raw = short || params.get('items') || '';
      return raw.split(short ? '~' : ',').map(function (part) {
        var bits = part.split(short ? '.' : ':');
        var item = { h: bits[0], q: clamp(parseInt(bits[2], 10) || 1, 1, MAX_QTY) };
        if (short && /^\d{1,3}$/.test(bits[1] || '')) item.n = parseInt(bits[1], 10);
        else item.v = String(bits[1] || '').replace(/^id/, '');
        if (!validItem(item)) return null;
        var key = item.h + '|' + (item.n || item.v);
        if (seen[key]) return null;
        seen[key] = true;
        return item;
      }).filter(Boolean).slice(0, MAX_ITEMS);
    }

    renderListPage() {
      var w = this.readWish();
      var items = this.parseItems(w.params);
      if (!items.length) return;
      var root = rootPath(this.data);

      /* Aktuelle Daten aus dem Shop: Titel, Bild, Preis, Verfügbarkeit in der Seitensprache */
      Promise.all(items.map(function (item) {
        return fetch(root + 'products/' + encodeURIComponent(item.h) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product || !Array.isArray(product.variants)) return null;
            var variant = item.n ? product.variants[item.n - 1] || null : null;
            if (!variant) product.variants.forEach(function (v) { if (String(v.id) === String(item.v)) variant = v; });
            return variant ? { item: item, product: product, variant: variant } : null;
          })
          .catch(function () { return null; });
      })).then(function (rows) {
        rows = rows.filter(Boolean);
        if (rows.length) this.buildList(rows, w);
      }.bind(this));
    }

    buildList(rows, w) {
      var t = this.i18n;
      var format = this.data.moneyFormat;

      var card = make('article', 'ec-wish-dialog ec-wish-card ec-wish-card--page ec-wish-card--list');
      var inner = make('div', 'ec-wish-card__inner');

      inner.appendChild(make('h1', 'ec-wish__title', w.from ? fill(t.listFrom, '%NAME%', w.from) : t.listAnon));
      if (w.msg) inner.appendChild(this.noteEl(w.msg));

      var list = make('ul', 'ec-wish-entries');
      var giftable = [];

      rows.forEach(function (row) {
        var product = row.product;
        var v = row.variant;
        var qty = row.item.q;
        var single = product.variants.length === 1 && /^default title$/i.test(v.title || '');

        var li = make('li', 'ec-wish-entry');

        var media = make('a', 'ec-wish-entry__media');
        media.href = this.productUrl(product.handle, v.id);
        media.setAttribute('aria-hidden', 'true');
        media.tabIndex = -1;
        var src = product.featured_image || (v.featured_image && v.featured_image.src);
        if (src) {
          var img = make('img');
          img.src = String(src).replace(/^\/\//, 'https://') + (String(src).indexOf('?') > -1 ? '&' : '?') + 'width=300';
          img.alt = '';
          img.width = 88;
          img.height = 88;
          img.loading = 'lazy';
          media.appendChild(img);
        }
        li.appendChild(media);

        var body = make('div', 'ec-wish-entry__body');
        body.appendChild(make('h2', 'ec-wish-entry__title', product.title));
        body.appendChild(make('p', 'ec-wish-entry__meta',
          (qty > 1 ? qty + ' × ' : '') + (single ? '' : v.title + ' · ') + formatMoney(v.price, format)));

        var error = this.errorEl();
        var actions = make('div', 'ec-wish-entry__actions');
        if (v.available) {
          var one = [{ id: v.id, quantity: qty }];
          giftable.push(one[0]);
          var btn = this.giftButton(t.giftOne, one, w.from, error, { variant_id: v.id, product_handle: product.handle });
          btn.classList.add('ec-wish__btn--small');
          actions.appendChild(btn);
        } else {
          actions.appendChild(make('span', 'ec-wish-entry__unavailable', t.unavailable));
        }
        var look = make('a', 'ec-wish-card__later', t.view);
        look.href = this.productUrl(product.handle, v.id);
        actions.appendChild(look);
        body.appendChild(actions);
        body.appendChild(error);

        li.appendChild(body);
        list.appendChild(li);
      }.bind(this));

      inner.appendChild(list);

      var deadline = this.deadlineText();
      if (deadline) inner.appendChild(make('p', 'ec-wish-card__deadline', deadline));

      if (giftable.length > 1) {
        var allError = this.errorEl();
        var all = make('div', 'ec-wish-card__actions');
        all.appendChild(this.giftButton(t.giftAll, giftable, w.from, allError, { all: true }));
        inner.appendChild(all);
        inner.appendChild(allError);
      }

      card.appendChild(inner);
      this.mount(card);
      track('wish_opened', { items: rows.length });
    }
  }

  window.customElements.define('ec-wish', EcWish);
})();
